import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'Login', index: 0 },
    component: () => import('@/page/login.vue')
  },
  {
    path: '/projectList',
    name: 'ProjectList',
    meta: { title: 'Project List', index: 1, requiresAuth: true },
    component: () => import('@/page/projectList.vue')
  },
  {
    path: '/createProject',
    name: 'CreateProject',
    meta: { title: 'Create Project', index: 2, requiresAuth: true },
    component: () => import('@/page/createProject.vue')
  },
  {
    path: '/createProjectForm',
    name: 'CreateProjectForm',
    meta: { title: 'Project Form', index: 3, requiresAuth: true },
    component: () => import('@/page/createProjectForm.vue')
  },
  {
    path: '/editProjectForm/:projectId',
    name: 'EditProjectForm',
    meta: { title: 'Edit Project Form', index: 3, requiresAuth: true },
    component: () => import('@/page/editProjectForm.vue')
  },
  {
    path: '/workOrderList/:id',
    name: 'WorkOrderList',
    meta: { title: 'Work Order List',  index: 2, requiresAuth: true },
    component: () => import('@/page/workOrderList.vue')
  },
  {
    path: '/createWorkOrder',
    name: 'CreateWorkOrder',
    meta: { title: 'Create Work Order', index: 3, requiresAuth: true },
    component: () => import('@/page/createWorkOrder.vue')
  },
  {
    path: '/logList/:id',
    name: 'LogList',
    meta: { title: 'Log List',index: 3, requiresAuth: true },
    component: () => import('@/page/logList.vue')
  },
  {
    path: '/logDetail/:id',
    name: 'LogDetail',
    meta: { title: 'Log Detail', keepAlive: false, index: 4, requiresAuth: true },
    component: () => import('@/page/logDetail.vue')
  },
  {
    path: '/invoiceDetail/:id',
    name: 'InvoiceDetail',
    meta: { title: 'Invoice Detail', index: 4, requiresAuth: true },
    component: () => import('@/page/invoiceDetail.vue')
  },
  {
    path: '/superLog',
    name: 'SuperLog',
    meta: { title: 'Super Log', keepAlive: true, index: 1, requiresAuth: true },
    component: () => import('@/page/superLog.vue')
  },
  {
    path: '/superLog2026',
    name: 'SuperLog',
    meta: { title: 'Super Log', keepAlive: true, index: 1, requiresAuth: true },
    component: () => import('@/page/superLog2026.vue')
  },
  {
    path: '/superSignIn',
    name: 'SuperSignIn',
    meta: { title: 'Super Sign In', keepAlive: true, index: 2, requiresAuth: true },
    component: () => import('@/page/superSignIn.vue')
  },
  {
    path: '/superJournal',
    name: 'SuperJournal',
    meta: { title: 'Super Journal', keepAlive: true, index: 2, requiresAuth: true },
    component: () => import('@/page/superJournal.vue')
  },
  {
    path: '/superInvoice',
    name: 'SuperInvoice',
    meta: { title: 'Super Invoice', keepAlive: true, index: 2, requiresAuth: true },
    component: () => import('@/page/superInvoice.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    meta: { title: 'Page Not Found' },
    component: () => import('@/page/notFound.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

let isRedirectingToLogin = false;

router.beforeEach((to, from, next) => {
  const routeName = to.name;
  const customTitle = store.getters.getPageTitle(routeName);
  const defaultTitle = to.meta.title || 'JLDA';
  const pageTitle = customTitle || defaultTitle;
  document.title = pageTitle;

  if (to.name === 'Login') {
    isRedirectingToLogin = false;
  }

  if (to.meta.requiresAuth) {
    if (!store.getters.isLogin) {
      if (isRedirectingToLogin) {
        return next(false);
      }
      isRedirectingToLogin = true;
      return next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
    }
  }

  if (to.name === 'Login' && store.getters.isLogin) {
    return next({ name: 'ProjectList' });
  }

  next();
});

router.setRedirectingToLogin = (value) => {
  isRedirectingToLogin = value;
};

export default router;
